import Input from './Input';
import Select from './Select';
import Checkbox from './Checkbox';
import Radio from './Radio';
import DateRange from './DateRange';
import DateTime from './DateTime';
import AsyncSelect from './AsyncSelect';
import ButtonGroupSelect from './ButtonGroupSelect';
import Switcher from './Switcher';

const FormikFields = {
  AsyncSelect,
  Input,
  Select,
  Checkbox,
  Radio,
  DateRange,
  DateTime,
  ButtonGroupSelect,
  Switcher,
};

export default FormikFields;
